import  ArrowRight  from '../../components/Images/ArrowRight'
import styled from 'styled-components/macro'
import { flex } from 'styled-system'

export const flexCenterDiv = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}

export const ArrowWhite = styled(ArrowRight)`
  margin-left: 8px;
`

export const widgetsContainer = {
  px: ['0','120px'],
  py:[0,'8px'],
  backgroundColor: 'surface.sf300'
}
export const newNovelMobileContainer = {
  position: 'relative',
}
export const videoContainer = {
  height:'70vh',
  backgroundColor: '#000',
  display: `${window.screen.width > '400px'  && 'none'}`
}
export const formContainer = {
    borderRadius: '0.8rem 0.8rem 0rem 0rem',
    backgroundColor: 'surface.foreground',
    p:'16px',
    position: 'fixed',
    bottom: '0px',
    left: '0px',
    width: '100%',
    height: 'auto',
    transition: 'all 0.2s'
}
export const NewNovelHeading = styled.h3`
  font-size: 1rem;
  margin-bottom: 0.5rem;
  a {
    text-decoration: underline;
  }
`
export const errorText = {
  fontSize:'M.XS',
  color: 'interactive.punch2',
  mt: '0.5rem'
}

export const VideoNotificationBanner = styled.div`
  background-color: #fff;
  margin: 0.1rem auto 1rem auto;
  width: 100%;
  max-width: 35rem;
`
export const VideoNotification = styled.div`
  background-color: var(--corn-op-24);
  color: var(--Corn800);
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0.8rem 0.5rem;
`
export const PlayIconBtn = styled.button`
  all: unset;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
`
export const VideoBannerContent = styled.p`
 line-height: 1.43;
`
export const contestContainerHeading = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  m: '0.5rem'
}

export const contestList = {
  display: 'flex',
  flexDirection: 'column',
  m: '0.5rem',
}

export const contestListItem = {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: '0.6rem',
  px: '1rem',
  backgroundColor:'surface.foreground',
  mb: '0.8rem',
  borderRadius: '0.5rem'
}

export const contestHeading = {
  fontSize: 'M.M',
  fontWeight: 'b',
  lineHeight: '1.33',
  color: 'var(--Text700)',
  pr:'8px',
  ml: 8
}

export const contestDuration = {
  color: 'interactive.azure2',
  fontSize: '0.875rem',
  display: 'flex',
  my: ['0.4rem', '0']
}

export const contestStatus={
  display: 'flex',
  alignItems:'center',
  textTransform: 'capitalize'
}

export const StatusCircle=styled.div`
  height:0.8rem;
  width:0.8rem;
  border-radius:100%;
  background-color:${props=>{
    if(props.status === "Not Registered") return "var(--Fjord500)";
    else if(props.status === "Book Published") return "var(--Lime500)";
    else if(props.status === "Book Created") return "var(--Punch500)";
  }};
  margin-right:0.2rem;
`

export const descriptionCard = {
  backgroundColor: "rgba(242, 198, 2, 0.16)",
  borderRadius: '4px',
  my: '16px',
  p: '16px',
  border: 'solid 1px rgba(242, 198, 2, 0.24)'
}
export const descriptionText = {
  fontSize: 'M.XS',
  color: 'interactive.corn3',
  lineHeight: '1.43',
  textAlign: ['center','left']
}

export const contestThumbnailContainer = {
  height: '5.5rem',
  ml: '1rem',
  width: ['102px','124px'],
  height: ['76px','88px'],
}

export const contestThumbnailImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '4px'
}

export const allContestHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mx:'0.5rem',
  mb:'1rem'
}

export const backButton = {
  all: 'unset',
  cursor: 'pointer',
  backgroundColor: 'unset',
  border : 'none'
}
export const contestDetails = {
  display: 'flex',
  alignItems: ["unset","center"],
  flexDirection: ['column','row'],
  justifyContent: 'space-between'
}

export const ContestTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
  color: var(--text700);
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
  @media(max-width:600px){
    margin:8px 0 0;
  }
`

export const wbpBookCard = {
  mb:'8px',
  p:['16px','24px'],
  backgroundColor: 'surface.foreground',
  maxWidth: ['100vw','unset']
}
export const TopCardSection = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`

export const wbpThumbnail = {
  borderr: '4px',
  boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)',
  width: ['44px','auto'],
  height: ['66px','auto'],
  mr: '16px',
  backgroundColor: 'surface.sf100',
  cursor: 'pointer',
}
export const wbpDetails = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
}
export const title = {
  fontSize: 'D.L',
  fontWeight: 'b',
  lineHeight: '1.33',
  textAlign: 'left',
  mb: '8px',
  maxWidth:['40vw','unset'],
  color: 'text.text700'
}

export const subtext = {
  fontSize: ['M.S','D.M'],
  lineHeight: '1.2',
  textAlign: 'left',
  fontWeight: ['b','unset'],
  mb: '8px',
  color: 'text.text700'
}
export const SubTitle = styled.p`
  font-size: 20px;
  line-height: 1.43;
  text-align:left;
  font-weight: bold;
  margin-bottom: 8px;
  color:var(--storm-text-storm-700);
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const description = {
  fontSize: 'D.S',
  lineHeight: '1.5',
  textAlign: 'left',
  color: 'text.text500' 
}
export const ctaBox = {
  display: 'flex',
  mt: ['16px','0px'],
  justifyContent: ['center','unset']
}
export const bottomCardSection = {
  padding: '12px',
  borderRadius: '4px',
  border: 'solid 1px surface.sf900',
  backgroundColor: 'surface.sf100',
  display: 'flex',
  justifyContent: 'space-between',
  mt: '24px',
  flexDirection: ['column', 'row']
}
export const bookProgressBar = {
  display: 'flex',
  flexDirection: 'column',
  width: ['100%','80%'],
  mb: ['16px',0]
}
export const wordsProgress = {
  mb: '8px',
  fontSize: '16px',
  lineHeight: '1.5',
  textAlign: 'left',
  color: 'text.text500'
}
export const progressDivOuter = {
  borderRadius: '4px',
  backgroundColor: 'rgba(6,138,226, 0.3)',
  height: '8px'
}
export const ProgressDivInner = styled.div`
  height: 8px;
  background-color: var(--Azure500);
  border-radius: 4px;
  width: ${({ width }) => width || 0}%;
`
export const accountProgress = {
  display: 'flex',
  justifyContent: 'space-between',
  my: '24px',
  flexDirection: ['column','row']
}
export const creatorDetailsBox = {
  display: 'flex',
  mx:['auto',0],
  mb:['16px',0]
}

export const creatorImage = {
  width: '48px',
  height: '48px',
  boxShadow: 'inset 0 0 4px 0 rgba(0, 0, 0, 0.16)',
  borderRadius: '50%',
  mr: '16px'
}
export const creatorDetails = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}
export const CreatorName = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text700);
  text-transform: capitalize;
`
export const StepsDiv = styled.div``

export const BookAction = styled.div`
  cursor: pointer;
  padding:16px;
  border-radius: 4px;
  background-color: ${({ enabled }) => enabled ? "var(--Azure500)" : "#e6e6e6"};
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  text-align: center;
  color: ${({ enabled }) => enabled ? "rgba(255, 255, 255, 0.98)" : "var(--Text100)"};
  display:flex;
  justify-content: center;
  align-items: center;
`
export const BookActionWhite = styled(BookAction)`
  background-color: var(--dove);
  color: var(--Text500);
  margin-left: 16px;
`

export const ActionBox = styled.div`
  float: right;
  padding: 8px;
  display: flex;
`
export const ActionButtonWhite = styled.div`
  border-radius: 4px;
  border: solid 2px var(--LD10);
  cursor: pointer;
  padding: 14px;
  width: 180px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Text500);
  margin-left: 16px;
`

export const actionWhiteButton = {
  borderRadius: '4px',
  border: 'solid 2px var(--LD10)',
  cursor: 'pointer',
  p: ['12px','16px'],
  textAlign:'center',
  fontSize: 'D.XS',
  fontWeight: 'b',
  lineHeight: '1.43',
  color: 'text.text500',
  ml:'16px',
  display: 'flex',
  justifyContent:'center',
  alignItems: 'center',
  cursor: 'pointer'
}

export const bottomHr = {
  mt: ['8px','32px'],
  mb: '0px',
  height: '2px',
  backgroundColor: 'surface.sf300'
}
export const statsHolder = {
  mt: '24px',
  // mb: '-8px'
}

export const NotificationCardHolder = styled.div``
export const TabsHolder = styled.div`
  background-color: var(--Dove);
  padding: 8px;
  display: flex;
  height: 112px;
  background-color: var(--Dove);
  margin: 4px 0 1px;
  display:flex;
  @media(max-width:600px){
    max-width:100vw;
    padding-left: 0;
  }
`
export const Tab = styled.div`
  margin-right: ${({ last }) => !last ? '16px' : '0'};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap:4px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme, active, alwaysActive }) => alwaysActive || active ? theme.colors.interactive.azure2 : theme.colors.text.text300};

  @media (max-width: 600px) {
    margin-right: ${({ last }) => !last ? '12px' : '0'};
    max-width: ${({ last }) => !last ? '24vw' : '16vw'};
  }
`
export const TabNameSpan = styled.span`
  white-space: nowrap;
  padding: 8px;
  text-align:center;
  border: ${({ theme, active, alwaysActive }) => active && !alwaysActive ? `solid 2px ${theme.colors.interactive.azure2}` : 'none'};
  border-bottom: ${({ theme, active, alwaysActive }) => active || alwaysActive ? `solid 2px ${theme.colors.interactive.azure2}` : 'none'};
  border-radius: ${({ alwaysActive }) => alwaysActive ? '0px' : '8px'};
  &:hover {
    border-radius: 4px;
    background-color: #f0f1f5;
  }
  @media (max-width: 600px) {
    &:hover {
      background-color: unset;
    }
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
export const TabValueSpan = styled(TabNameSpan)`
    border : none;
`

export const UnderLine = styled.div`
  width: 32px;
  height: 2px;
  border-radius: 2px;
  background-color: 'var(--Azure500)';
`
export const card = {
  maxWidth: ['100vw','350px'],
  my: '16px',
  display:'flex',
  p: '16px',
  borderRadius: '8px',
  border: 'solid 1px #1dbebb',
  borderLeft: 'solid 8px #1dbebb',
  backgroundColor: '#eff7f3'
}

export const Card = styled.div`
  width: 350px;
  margin: 16px 0;
  padding: 16px;
  display: flex;
  border-radius: 8px;
  border: ${({ color }) =>  `solid 1px ${color}`};
  border-left: ${({ color }) =>  `solid 8px ${color}`};
  background-color: #eff7f3;
  @media(max-width:600px){
    width: 100vw;
  }
`

export const CardHeading = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: rgba(13, 21, 54, 0.66);
`
export const CardImg = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
`
export const CardSubHeading = styled.div`
  padding-top:8px;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: rgba(13, 21, 54, 0.66);
`

export const BookCard = styled.div`
  margin-bottom: 8px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.surface.foreground};

  @media (max-width: 600px) {
    padding: 16px;
    max-width: 100vw;
  }
`
export const TopSection = styled.div`
  display: flex;
`
export const ThumbnailDiv = styled.div`
  width: 112px;
  min-width: 112px;
  height: 168px;
  border-radius: 4px;
  background-color: var(--Grey300);
  margin-right: 24px;

  img {
    width: 112px;
    height: 168px;
    border-radius: 4px;
  }
`
export const DetailsDiv = styled.div`
  overflow:hidden;
`
export const BookTitle = styled.p`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.33;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

`
export const AuthorName = styled.div`
  font-size: 16px;
  line-height: 1.2;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
`
export const Description = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text700);
  margin-bottom: 8px;
`
export const StatsDiv = styled.div`
  display: grid;
  grid-template-columns: ${({ newVersion }) => newVersion ? 'repeat(5,1fr)' : 'repeat(5,0fr)'};
  grid-gap: ${({ newVersion }) => newVersion ? '8px' : '24px'};
  @media(max-width: 600px){
    grid-template-columns: repeat(5,1fr);
    grid-gap: 8px;
  }
`
export const Metric = styled.div`
  display: flex;
  flex-direction: column;

  &:last-child {
    margin-right: 0;
  }
  @media(max-width:600px){
    margin-right: 0;
  }
`
export const Count = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: var(--Text700);
  margin-bottom: 4px;
  @media(max-width:600px){
    font-size: 16px;
  }
`
export const Label = styled.div`
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color: var(--Text500);
  margin-top: auto;
`
export const CtaBox = styled.div`
  display: flex;
  gap:8px;
`
export const daysMissedDiv = {
  ...actionWhiteButton,
  border: 'solid 2px interactive.azure2',
  color: 'interactive.azure2',
  backgroundColor: 'rgba(6, 138, 226, 0.1)'
}
export const timeLeftDiv = {
  fontSize: 'D.XS',
  lineHeight: '1.43',
  textAlign: ['center','left'],
  color: 'interactive.lime2',
  mt: '8px'
}
export const hr = {
  height: '2px',
  backgroundColor: 'var(--Grey300)',
  mt: '24px',
  mb: '12px'
}

export const content = {
  ...flexCenterDiv,
  flexDirection: ['column','row'],
  mt:['16px',0]
}
export const Title = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: left;
  color: var(--Text500);
`
export const titleExpanded = {
  fontSize: '18px',
  fontWeight: 'b',
  lineHeight: '1.33',
  textAlign: 'left',
  color: 'text.text700'
}
export const titlePayment = {
  ...titleExpanded,
  textAlign:'center'
}

export const TimelineDiv = styled.div`
  min-width: 670px;

  @media (max-width: 600px) {
    min-width: 90vw;
  }
`
export const HelpText = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: left;
  color: var(--text-500);
  margin-bottom: 24px;
`





export const step2Container = {
  pt:['24px','48px'],
  pb:'24px',
  px:['16px','48px'],
  backgroundColor: 'surface.foreground',
}
export const stepHeading = {
  fontSize: 'D.XL',
  fontWeight: 'b',
  lineHeight: '1.25',
  textAlign: 'center',
  color: 'text.text500',
  mb: '24px'
}
export const stepDesc = {
  ...stepHeading,
  fontSize: 'D.S',
  lineheight: '1.5',
  fontWeight: 'r',
}
export const okayBtn = {
  py: 8,
  px: 16,
  borderRadius: 4,
  border: 'solid 2px var(--LD10)',
  fontSize: 'D.XS',
  fontWeight: 'b',
  textAlign: 'center',
  ml: 'auto',
  color: 'text.text500',
  display: 'table',
  cursor: 'pointer'
}

export const artDiv = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width:['90vw','unset']
}



export const ProgressArm1 = styled.div`
  width: ${({ width }) => "calc(" + (width || 0) + "% - " + (width) + "px)"};
  // @media (max-width: 600px) {
  //   height: ${({ width }) => "calc(" + (width || 0) + "% - " + (width) + "px)"};
  // }
`
export const ProgressArm2 = styled.div`
  // width: ${({ width }) => width || 0}%;
  width: ${({ width }) => "calc(" + (width || 0) + "% - " + (width) + "px)"};
  // @media (max-width: 600px) {
  //   height: ${({ width }) => "calc(" + (width || 0) + "% - " + (width) + "px)"};
  // }
`

export const ProgressDivOuter = styled.div`
  border-radius: 4px;
  background-color: var(--Grey300);
  height: 8px;
`

export const TopLevel = styled.div`
  display: flex;
  justify-content: space-between;
`
export const MidLevel = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin: 0 14px;
  }
`
export const BottomLevel = styled.div`
  display: flex;
  justify-content: space-between;
`
export const CurrentLabel = styled.span`
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: var(--Text500);
`
export const MileStoneLabel = styled(CurrentLabel)``
export const MileStoneAward = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: var(--Text500);
  // margin-left: ${({ margin }) => "calc(" + (margin || 0) + "% - " + (margin * 1.2) + "px)"};
`
export const MileStoneAwardDummy = styled(MileStoneAward)`
  visibility: hidden;
`
export const MobileLabelsContainer = styled.div`
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  height: 56px;
  width:100%;
  margin-left: 24px;
`
export const StepLabelMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

export const TimerInfo = styled.div`
  border:1px solid var(--Azure500);
  color: var(--azure-500);
  padding: 16px;
  border-radius: 4px;
  background:rgba(6,138,226,0.1);
  margin: 16px auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  svg{
    margin-right: 8px;
    fill:var(--azure-500);
    
    path{
      fill: inherit;
      fill-opacity: 1;
    }
  }
`
export const MailLink = styled.a`
    text-decoration: None;
    color: var(--Azure500);
    font-weight: 600;
`